import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/**
 * The QR the operator scans to start capturing (F2).
 *
 * Rendered large and with high error correction, because it is read across a
 * workshop by a phone held in one hand, often at an angle, sometimes by
 * someone wearing gloves.
 */
export function QrCode({ url, size = 260 }: { url: string; size?: number }) {
  const [src, setSrc] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    QRCode.toDataURL(url, {
      errorCorrectionLevel: 'H', width: size, margin: 2,
      color: { dark: '#000000', light: '#ffffff' },
    })
      .then((data) => { if (!cancelled) setSrc(data); })
      .catch((err: Error) => { if (!cancelled) setError(err.message); });
    return () => { cancelled = true; };
  }, [url, size]);

  if (error) return <p className="muted">Could not draw the QR code: {error}</p>;
  if (!src) return <div className="qr-placeholder" style={{ width: size, height: size }} />;
  return <img className="qr" src={src} width={size} height={size} alt="Scan to capture" />;
}
